import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { userActions } from '@store/user';
import { UserNavView } from '@store/user';

@Injectable()
export class UserViewSelectorService {

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  public setActive(navView: UserNavView): void {
    this.router.navigate([], {
      relativeTo: this.route,
      fragment: navView === UserNavView.TRANSACTIONS ? UserNavView.BALANCE : navView,
    }).then();
    this.store.dispatch(userActions.setUserNavView({ navView: navView }));
  }
}
